import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';
import { PagedData } from '../../models/paging/paged-data';
import { Page } from '../../models/paging/page';
import { ServerData } from '../../models/paging/server-data';

import { Tablet } from '../../models/tablet';
import { UUID } from 'angular2-uuid';
import { SnotifyService } from 'ng-snotify';
import { environment } from '../../../environments/environment';

@Injectable()
export class TabletService {
  constructor(private http: HttpClient, private snotifyService: SnotifyService) { }

  public getAll(): Promise<Tablet[]> {
    const headers = {
      'Content-Type': 'application/json',
    };
    return new Promise((resolve, reject) => {
      this.http.get<Tablet[]>(environment.apiUrl + 'pdauser/getall').subscribe(data => {
        resolve(data);
      }, error => {
        console.log(error);
        reject();
      });
    });
  }

  public get(id: number): Promise<Tablet> {
    return new Promise((resolve, reject) => {
      this.http.get<Tablet>('/api/tablet/get?id=' + id).subscribe(data => {
        resolve(data);
      }, error => {
        console.log(error);
        reject();
      });
    });
  }

  public save(tablet: Tablet): Promise<Tablet> {
    return new Promise((resolve, reject) => {
      if (tablet.is_edit) {
        this.http.put<Tablet>('/api/tablet/put', tablet).subscribe(data => {
          resolve(data);
          this.snotifyService.success('Successfully updated tablet user');
        }, error => {
          console.log(error);
          reject();
        });
      } else {
        tablet.pdaUserId = UUID.UUID();
        console.log(tablet);
        this.http.post<Tablet>('/api/tablet/post', tablet).subscribe(data => {
          resolve(data);
          this.snotifyService.success('Successfully added tablet user');
        }, error => {
          console.log(error);
          reject();
        });
      }
    });
  }


  public authorise(id: string, pass: string): Promise<Tablet> {
    return new Promise((resolve, reject) => {
      this.http.get<Tablet>('/api/tablet/authorise?id=' + id + '&pass=' + pass).subscribe(data => {
        resolve(data);
      }, error => {
        reject();
      });
    });
  }

  public getResults(page: Page, name:string, expired:number): Promise<PagedData<Tablet>> {
    const pagedData = new PagedData<Tablet>();
    let params = "&expired=" + expired;
    params = params +"&name=" + name;
    return new Promise((resolve, reject) => {
      if (page.sortBy == undefined || page.sortBy == '') { page.sortBy = 'Firstname'; }
      if (page.sortOrder == undefined || page.sortOrder == '') { page.sortOrder = 'asc'; }
      this.http.get<ServerData>('/api/tablet/gettable?size=' + page.size + '&pageNumber=' + page.pageNumber + '&sortBy=' + page.sortBy + '&sortOrder=' + page.sortOrder + params).subscribe(data => {
        page.totalElements = data.total;
        page.totalPages = page.totalElements / page.size;
        for (let i = 0; i < data.data.length; i++) {
          const jsonObj = data.data[i];
          const tablet = new Tablet();
          tablet.init(jsonObj.id, jsonObj.firstname, jsonObj.lastname, jsonObj.pin, jsonObj.expired, jsonObj.created_Date_Formatted, jsonObj.isLead);
          pagedData.data.push(tablet);
        }

        pagedData.page = page;
        resolve(pagedData);

      }, error => {
        reject();
      });
    });
  }
  public getExcel(): Promise<any> {
    return new Promise((resolve, reject) => {


      this.http.get<any>('/api/tablet/getexcel').subscribe(data => {
        let blob = this.converBase64toBlob(data, 'application/vnd.ms-excel');
        resolve(blob);
      }, error => {
        console.log(error);
        reject();
      });
    });
  }
  converBase64toBlob(content, contentType) {
    contentType = contentType || '';
    let sliceSize = 512;
    let byteCharacters = window.atob(content); //method which converts base64 to binary
    let byteArrays = [
    ];
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      let slice = byteCharacters.slice(offset, offset + sliceSize);
      let byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      let byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    let blob = new Blob(byteArrays, {
      type: contentType
    }); //statement which creates the blob
    return blob;
  }
}
